import { QURAN_CREDIT, kemenagUrl } from '@iqrapath/shared'
import { SourceLink } from '../../components/SourceLink.tsx'
import type { AyatDetail, Tafsir } from './ayat.ts'
import { CtaBar, NextStep } from './parts.tsx'

function Deeper({ t }: { t: Tafsir }) {
  const tahlili = t.tahlili.filter((x) => x.text)
  const many = t.tema.length > 1
  return (
    <section aria-labelledby="deeper-h">
      <h2 id="deeper-h" className="section-t">Baca lebih dalam</h2>
      <div className="card acc">
        {tahlili.length > 0 && (
          <details>
            <summary>Tafsir Tahlili</summary>
            {tahlili.map((x) => (
              <div key={x.k} className="acc-part">
                {tahlili.length > 1 && <b>Ayat {x.k}</b>}
                <p className="prose">{x.text}</p>
              </div>
            ))}
          </details>
        )}
        {t.tema.map((g) => (
          <div key={g.dari} className="acc-group">
            {g.judul && <p className="eyebrow acc-eyebrow">Tema ayat {g.dari}–{g.sampai}: {g.judul}</p>}
            {g.sababNuzul && g.sababNuzul.length > 0 && (
              <details>
                <summary>Sebab turunnya ayat{many ? ` ${g.dari}–${g.sampai}` : ''}</summary>
                {g.sababNuzul.map((s, i) => <p key={i} className="prose acc-part">{s}</p>)}
              </details>
            )}
            {g.kosakata && (
              <details>
                <summary>Kosakata{many ? ` ayat ${g.dari}–${g.sampai}` : ''}</summary>
                <p className="prose acc-part">{g.kosakata.replace(/^Kosakata:\s*/i, '')}</p>
              </details>
            )}
            {g.munasabah && (
              <details>
                <summary>Kaitan dengan ayat sebelumnya</summary>
                <p className="prose acc-part">{g.munasabah}</p>
              </details>
            )}
            {g.kesimpulan && g.kesimpulan.length > 0 && (
              <details>
                <summary>Kesimpulan</summary>
                {g.kesimpulan.map((s, i) => <p key={i} className="prose acc-part">{s}</p>)}
              </details>
            )}
          </div>
        ))}
        {t.pengantar && (
          <details>
            <summary>Tentang surat ini</summary>
            <p className="prose acc-part">{t.pengantar}</p>
          </details>
        )}
      </div>
    </section>
  )
}

/** Step 3: the curated reflection, then Kemenag's tafsir for whoever wants to go deeper. */
export function Renungi({ d, day }: { d: AyatDetail; day: number }) {
  const a = d.ayat
  const key = a.kataKunci ? a.verses?.find((v) => v.k === a.ayatFrom)?.kata?.[a.kataKunci - 1] : undefined
  const wajiz = (a.verses ?? []).filter((v) => v.wajiz)

  return (
    <>
      <p className="step-hint">Bahan untuk dipikirkan bersama hatimu, bukan keputusan hukum.</p>

      <section className="card prose-card" aria-labelledby="makna-h">
        <div className="card-h">
          <h2 id="makna-h">Makna</h2>
          {!a.reviewed && <span className="pill pill-amber">Menunggu tinjauan ustadz</span>}
        </div>
        <p className="prose">{a.makna}</p>
      </section>

      {a.catatanKata && (
        <section className="card prose-card" aria-labelledby="kunci-h">
          <h2 id="kunci-h">Catatan kata kunci</h2>
          {key && (
            <p className="key-word">
              <span className="ar" lang="ar" dir="rtl">{key.ar}</span>
              {key.arti && <span>{key.arti}</span>}
            </p>
          )}
          <p className="prose">{a.catatanKata}</p>
        </section>
      )}

      {a.terjemah && (
        <section className="card prose-card" aria-labelledby="tr-h">
          <h2 id="tr-h">Terjemah</h2>
          <p className="prose">“{a.terjemah}”</p>
          <p className="src"><SourceLink href={kemenagUrl(a.surah, a.ayatFrom, a.ayatTo)}>{a.ref}</SourceLink></p>
        </section>
      )}

      {wajiz.length > 0 && (
        <section className="card prose-card" aria-labelledby="wajiz-h">
          <h2 id="wajiz-h">Tafsir Ringkas</h2>
          {wajiz.map((v) => (
            <div key={v.k} className="acc-part">
              {wajiz.length > 1 && <b>Ayat {v.k}</b>}
              <p className="prose">{v.wajiz}</p>
            </div>
          ))}
        </section>
      )}

      {a.tafsir && <Deeper t={a.tafsir} />}
      {(wajiz.length > 0 || a.tafsir) && <p className="credit"><SourceLink href={kemenagUrl(a.surah, a.ayatFrom, a.ayatTo)}>{QURAN_CREDIT}</SourceLink></p>}

      <p className="help" style={{ textAlign: 'center', marginTop: 18 }}>Bahan renungan, bukan fatwa. Untuk urusan hukum fikih, tanyakan ke ustadz.</p>

      <CtaBar><NextStep day={day} step="amalkan" /></CtaBar>
    </>
  )
}
